import { useBranchOwner } from "@/hooks/use-branch-owner";
import { DoctorBranchRolesRoleOptions } from "@/types/pocketbase";

export function useBranchRole(): DoctorBranchRolesRoleOptions | undefined {
	const { isOwner, isGuest } = useBranchOwner();
	if (isOwner) return DoctorBranchRolesRoleOptions.owner;
	if (isGuest) return DoctorBranchRolesRoleOptions.guest;
	return undefined;
}
